import { threadTitleUpdate } from '../../threads/slices/threads';
import { INTERACTIVE_TOOL } from 'copilot-toolkit/constants/Tools';
import Raven from 'raven-js';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useCheckForCsatSurvey } from '../../chat/hooks/useCheckForCsatSurvey';
import { chatV2Actions } from '../../chat/slices/chatv2';
import { useCollaborateCopilotActions } from '../../hooks/useCollaborateCopilotActions';
/**
 * All Ably channel message event-handlers should be added here
 * These handlers are attached to every Ably channel we connect to
 */
export const useGetSubscriptionHandler = ({
  threadId
}) => {
  const dispatch = useDispatch();
  const checkForCsatSurvey = useCheckForCsatSurvey();
  const {
    handleCopilotAction
  } = useCollaborateCopilotActions();
  return useCallback(message => {
    try {
      const data = typeof message.data === 'string' ? JSON.parse(message.data) : message.data;
      switch (message.name) {
        case 'user_message':
          {
            // We currently ignore the user message but may need it for future reference.
            break;
          }

        // Start of conversation
        case 'copilot_response_start':
          {
            dispatch(chatV2Actions.chatResponseStarted(data));
            break;
          }
        // Message loop
        case 'copilot_response_message_start':
          {
            dispatch(chatV2Actions.chatResponseMessageStarted(data));
            break;
          }
        case 'copilot_response_message_delta':
          {
            dispatch(chatV2Actions.chatResponseMessageDelta(data));
            break;
          }
        case 'copilot_response_message_end':
          {
            dispatch(chatV2Actions.chatResponseMessageEnded(data));
            break;
          }
        /*
         * Interactive mode messages
         */
        case 'interactive_tool_call':
          {
            // Note: this will be invoked in `copilot-toolkit/hooks/useInteractiveModeSession.ts`
            handleCopilotAction(Object.assign({
              actionType: INTERACTIVE_TOOL
            }, data));
            // There is a section in the message.
            dispatch(chatV2Actions.chatToolCallEnded(data));
            break;
          }

        // Tools
        case 'copilot_tool_call_start':
          {
            dispatch(chatV2Actions.chatToolCallStarted(data));
            break;
          }
        case 'copilot_tool_call_end':
          {
            dispatch(chatV2Actions.chatToolCallEnded(data));
            break;
          }

        // End of conversation
        case 'copilot_response_end':
          {
            dispatch(chatV2Actions.chatResponseEnded(data));
            checkForCsatSurvey();
            break;
          }

        // User Confirmation
        case 'copilot_confirmation_response_acknowledged':
          {
            dispatch(chatV2Actions.chatConfirmationResponseAcknowledged(data));
            break;
          }

        // Update thread title
        case 'thread_title_update':
          {
            dispatch(threadTitleUpdate({
              id: threadId,
              title: data.title
            }));
            break;
          }
        // Exception handling
        case 'copilot_response_exception':
          {
            dispatch(chatV2Actions.chatResponseException(data));
            break;
          }
        default:
          throw new Error(`Unknown message name: ${message.name}`);
      }
    } catch (error) {
      Raven.captureException(error, {
        extra: {
          eventName: message.name
        }
      });
    }
  }, [dispatch, threadId, checkForCsatSurvey, handleCopilotAction]);
};